export default __webpack_public_path__ + "./images/how-2.webp";